import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'
import { ThermostatBrand } from '@/types/brand'
import { ThermostatBrandName } from '@/types/thermostatBrands'
import { match, P } from 'ts-pattern'

/**
 * Returns the thermostat brand list with Ecobee hidden unless EITHER:
 *  - the user is actively in the multi-program enrollment flow AND the selected
 *    MP program supports thermostats, OR
 *  - the user is already enrolled in a multi-program program that supports
 *    thermostats (so they can add or reconnect an Ecobee outside the flow).
 * Nest and Honeywell are always preserved.
 */
export function filterThermostatBrandsForMPFlow(
  brands: ThermostatBrand[],
  inFlow: boolean,
  deviceTypes: 'all' | DeviceType[],
  isLoadingOrIdle: boolean,
  isEnrolledInThermostatProgram: boolean,
): ThermostatBrand[] {
  const ecobeeAllowed = match({
    inFlow,
    deviceTypes,
    isLoadingOrIdle,
    isEnrolledInThermostatProgram,
  })
    // Hide while programs load so Ecobee never flashes on incomplete data.
    .with({ isLoadingOrIdle: true }, () => false)
    // Already enrolled in a thermostat-supporting program: allow reconnect/add.
    .with({ isEnrolledInThermostatProgram: true }, () => true)
    .with({ inFlow: false }, () => false)
    .with({ deviceTypes: 'all' }, () => false)
    .with({ deviceTypes: P.array(P.string) }, ({ deviceTypes }) =>
      deviceTypes.includes('thermostat'),
    )
    .exhaustive()

  if (ecobeeAllowed) {
    return brands
  }
  return brands.filter((brand) => brand.id !== ThermostatBrandName.Ecobee)
}
